import React from 'react';
import Alert from '../../../../components/Alert';
import { useAposentadosDemitidos } from '../../../../contexts/AposentadosDemitidos/context';

function Alertas() {
    const { alerts } = useAposentadosDemitidos();

    return (
        <>
            {alerts.map((alert, index) => (
                <Alert key={() => index} type={alert.tipo} title={alert.descricao} message={alert.complemento} />
            ))}
        </>
    );
}

export default Alertas;
